import script from "./AppHeaderNeighborhoodListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppHeaderNeighborhoodListItem.vue?vue&type=script&setup=true&lang=ts"

import "./AppHeaderNeighborhoodListItem.vue?vue&type=style&index=0&id=30a87841&lang=scss"

const __exports__ = script;

export default __exports__